export default __webpack_public_path__ + "static/cybersecurity-ride-hailing-protecting-driver-passenger-data-feature-1-f388f7afda680d6791afc4fb1b54ed03.png";